import React, { useState } from 'react';
import { Box, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ContactsIcon from '@mui/icons-material/Contacts';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PhoneIcon from '@mui/icons-material/Phone';
import { useSnackbar } from 'notistack';
import { submitTenantProfile } from '../checkInService';
import PrimaryActionButton from '../components/PrimaryActionButton';

function removeEmptyIdentityFields(value) {
  return Object.entries(value).reduce((payload, [key, fieldValue]) => {
    if((key === 'id' || key === 'uuid') && (fieldValue === '' || fieldValue === null || fieldValue === undefined || fieldValue === 0)){
      return payload;
    }

    return {
      ...payload,
      [key]: fieldValue,
    };
  }, {});
}

function getTenantProfilePayload(profile, { isNewUser = false, otp = '' } = {}) {
  console.log('profile---', profile)
  const inmateDetails = removeEmptyIdentityFields({
    id: isNewUser ? undefined : profile.inmateDetailsId,
    uuid: isNewUser ? undefined : profile.inmateDetailsUuid,
    name: profile.name || '',
    email: profile.email || '',
    emergencyContactName: profile.emergencyContactName || '',
    emergencyContactNumber: profile.emergencyContactNumber || '',
    address: profile.address || '',
    workplaceCollege: profile.workplaceCollege || '',
    workplaceCollegeAddress: profile.workplaceCollegeLocation || '',
    reference1: profile.reference1 || '',
    reference1Number: profile.reference1Number || '',
    reference2: profile.reference2 || '',
    reference2Number: profile.reference2Number || '',
  });
  console.log('isNewUser', isNewUser)
  const inmate = removeEmptyIdentityFields({
    id: isNewUser ? undefined : profile.id,
    uuid: isNewUser ? undefined : profile.uuid,
    mobile: profile.mobile || '',
    inmateDetails,
  });
  console.log('inmate',inmate)
  return {
    otp: isNewUser ? otp : undefined,
    inmate: {
      ...inmate,
    },
  };
}

function ProfileStep({ profile, otp = '', isNewUser = false, onChange, onSubmitSuccess }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
console.log('profile', profile)
  const profileFields = [
    { name: 'name', label: 'Name', icon: <BadgeIcon />, required: true },
    { name: 'mobile', label: 'Mobile Number', icon: <PhoneAndroidIcon />, maxLength: 10, helper: `${profile.mobile.replace(/\D/g, '').length}/10`, required: true, readOnly: true },
    { name: 'email', label: 'Email ID', icon: <EmailIcon />, type: 'email', required: true },
    { name: 'emergencyContactName', label: 'Emergency Contact Name', icon: <ContactsIcon />, required: true },
    { name: 'emergencyContactNumber', label: 'Emergency Contact Number', icon: <PhoneIcon />, required: true },
    { name: 'address', label: 'Address', icon: null, multiline: true, minRows: 3, required: true },
    { name: 'workplaceCollege', label: 'Workplace or College', icon: <BusinessCenterIcon /> },
    { name: 'workplaceCollegeLocation', label: 'Workplace or College Location', icon: <LocationOnIcon /> },
    { name: 'reference1', label: 'Reference 1', icon: <BadgeIcon /> },
    { name: 'reference1Number', label: 'Mobile Number', icon: <ContactsIcon /> },
    { name: 'reference2', label: 'Reference 2', icon: <BadgeIcon /> },
    { name: 'reference2Number', label: 'Mobile Number', icon: <ContactsIcon /> },
  ];

  const submitProfileDetails = () => {
    setIsSubmitting(true);

    submitTenantProfile(getTenantProfilePayload(profile, { isNewUser, otp })).then(({response, error}) => {
      setIsSubmitting(false);

      if(error){
        enqueueSnackbar(error?.message || 'Unable to submit profile details', {variant: 'error'});
        return;
      }

      enqueueSnackbar(response?.message || 'Profile details submitted successfully', {variant: 'success'});

      if(onSubmitSuccess){
        onSubmitSuccess(response?.data || response);
      }
    });
  };

  return (
    <Box component="form" onSubmit={(event) => { event.preventDefault(); submitProfileDetails(); }}>
      <Stack spacing={3}>
        {profileFields.map((field) => (
          <Box key={field.name}>
            <TextField
              value={profile[field.name]}
              onChange={onChange(field.name)}
              label={field.label}
              type={field.type || 'text'}
              required={field.required}
              multiline={field.multiline}
              minRows={field.minRows}
              inputProps={{ maxLength: field.maxLength }}
              InputLabelProps={field.readOnly ? { shrink: true } : undefined}
              InputProps={field.icon ? {
                readOnly: field.readOnly,
                startAdornment: (
                  <InputAdornment position="start">
                    {React.cloneElement(field.icon, { color: 'disabled' })}
                  </InputAdornment>
                ),
              } : undefined}
              fullWidth
            />
            {field.helper && (
              <Typography variant="body2" textAlign="right" sx={{ mt: 1 }}>
                {field.helper}
              </Typography>
            )}
          </Box>
        ))}
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
        <PrimaryActionButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </PrimaryActionButton>
      </Box>
    </Box>
  );
}

export default ProfileStep;
